import React, { useState } from "react";
import { Input, Modal, Button, Tooltip } from "antd";

const ICON_CATEGORIES = [
  { key: "all", label: "All Icons", icon: "la la-globe" },
  { key: "education", label: "Education & Learning", icon: "la la-graduation-cap" },
  { key: "badges", label: "Badges & Highlights", icon: "la la-star" },
  { key: "tech", label: "Tech & Coding", icon: "la la-code" },
  { key: "commerce", label: "Ecommerce & Commerce", icon: "la la-shopping-bag" },
  { key: "media", label: "Media & Content", icon: "la la-newspaper-o" },
  { key: "business", label: "Business & Office", icon: "la la-briefcase" },
];

const PRESET_ICONS = [
  // Education & Learning (50+ Specialized Icons)
  { class: "la la-graduation-cap", label: "Graduation Cap", category: "education" },
  { class: "la la-user-graduate", label: "Graduate Alum", category: "education" },
  { class: "la la-certificate", label: "Certificate", category: "education" },
  { class: "la la-award", label: "Academic Award", category: "education" },
  { class: "la la-scroll", label: "Diploma Scroll", category: "education" },
  { class: "la la-stamp", label: "Official Stamp", category: "education" },
  { class: "la la-file-signature", label: "Degree Document", category: "education" },
  { class: "la la-medal", label: "Honor Medal", category: "education" },
  
  { class: "la la-book", label: "Book", category: "education" },
  { class: "la la-book-open", label: "Open Book / Reading", category: "education" },
  { class: "la la-book-reader", label: "Study Reader", category: "education" },
  { class: "la la-file-alt", label: "Study Notes", category: "education" },
  { class: "la la-university", label: "University", category: "education" },
  { class: "la la-school", label: "School / Academy", category: "education" },
  { class: "la la-chalkboard-teacher", label: "Teacher / Lecturer", category: "education" },
  { class: "la la-chalkboard", label: "Blackboard / Lesson", category: "education" },
  { class: "la la-layer-group", label: "Curriculum Modules", category: "education" },
  { class: "la la-sitemap", label: "Learning Path", category: "education" },

  { class: "la la-laptop-code", label: "Coding Bootcamp", category: "education" },
  { class: "la la-brain", label: "Mind & Cognitive", category: "education" },
  { class: "la la-microscope", label: "Microscope Science", category: "education" },
  { class: "la la-flask", label: "Chemistry Lab", category: "education" },
  { class: "la la-vial", label: "Experiment Vial", category: "education" },
  { class: "la la-atom", label: "Physics Atom", category: "education" },
  { class: "la la-dna", label: "DNA Genetics", category: "education" },
  { class: "la la-calculator", label: "Math Calculator", category: "education" },
  { class: "la la-square-root-alt", label: "Square Root", category: "education" },
  { class: "la la-shapes", label: "Geometry Shapes", category: "education" },
  { class: "la la-user-astronaut", label: "Astronomy", category: "education" },
  { class: "la la-seedling", label: "Botany Biology", category: "education" },

  { class: "la la-language", label: "Languages", category: "education" },
  { class: "la la-spell-check", label: "Vocabulary", category: "education" },
  { class: "la la-atlas", label: "Atlas Geography", category: "education" },
  { class: "la la-globe-americas", label: "Global Learning", category: "education" },
  { class: "la la-history", label: "History Archives", category: "education" },
  { class: "la la-balance-scale", label: "Law & Legal Studies", category: "education" },

  { class: "la la-palette", label: "Art Palette", category: "education" },
  { class: "la la-paint-brush", label: "Paint Brush", category: "education" },
  { class: "la la-pen-fancy", label: "Literature Pen", category: "education" },
  { class: "la la-music", label: "Music Theory", category: "education" },
  { class: "la la-lightbulb-o", label: "Idea & Knowledge", category: "education" },
  { class: "la la-pencil-alt", label: "Pencil Writing", category: "education" },

  { class: "la la-tasks", label: "Exam Tasks", category: "education" },
  { class: "la la-edit", label: "Quiz Test", category: "education" },
  { class: "la la-hands-helping", label: "Mentorship", category: "education" },
  { class: "la la-user-friends", label: "Study Group", category: "education" },
  { class: "la la-clock-o", label: "Study Timer", category: "education" },
  { class: "la la-trophy", label: "Academic Competition", category: "education" },

  // Badges & Highlights
  { class: "la la-star", label: "Star", category: "badges" },
  { class: "la la-star-o", label: "Star Outline", category: "badges" },
  { class: "la la-fire", label: "Fire / Hot", category: "badges" },
  { class: "la la-trophy", label: "Trophy / Winner", category: "badges" },
  { class: "la la-crown", label: "Crown / VIP", category: "badges" },
  { class: "la la-medal", label: "Medal", category: "badges" },
  { class: "la la-diamond", label: "Diamond / Premium", category: "badges" },
  { class: "la la-gem", label: "Gem", category: "badges" },
  { class: "la la-award", label: "Award", category: "badges" },
  { class: "la la-bolt", label: "Flash / Instant", category: "badges" },
  { class: "la la-gift", label: "Gift / Bonus", category: "badges" },
  { class: "la la-percent", label: "Percent / Discount", category: "badges" },
  { class: "la la-shield", label: "Shield / Secure", category: "badges" },
  { class: "la la-check-circle", label: "Verified", category: "badges" },
  { class: "la la-heart", label: "Heart / Favorite", category: "badges" },
  { class: "la la-thumbs-up", label: "Thumbs Up / Like", category: "badges" },
  { class: "la la-sun-o", label: "Featured", category: "badges" },
  { class: "la la-bookmark", label: "Bookmark", category: "badges" },
  { class: "la la-tag", label: "Tag", category: "badges" },
  { class: "la la-tags", label: "Tags", category: "badges" },
  { class: "la la-magic", label: "Magic / Special", category: "badges" },
  { class: "la la-bullseye", label: "Bullseye / Target", category: "badges" },
  { class: "la la-rocket", label: "Rocket / Launch", category: "badges" },

  // Tech & Coding
  { class: "la la-code", label: "Code", category: "tech" },
  { class: "la la-laptop", label: "Laptop", category: "tech" },
  { class: "la la-desktop", label: "Desktop", category: "tech" },
  { class: "la la-terminal", label: "Terminal / Console", category: "tech" },
  { class: "la la-database", label: "Database", category: "tech" },
  { class: "la la-server", label: "Server", category: "tech" },
  { class: "la la-bug", label: "Bug / Debug", category: "tech" },
  { class: "la la-file-code", label: "Code File", category: "tech" },
  { class: "la la-git", label: "Git", category: "tech" },
  { class: "la la-cloud", label: "Cloud", category: "tech" },
  { class: "la la-microchip", label: "CPU / Chip", category: "tech" },
  { class: "la la-network-wired", label: "Network", category: "tech" },
  { class: "la la-robot", label: "AI / Robot", category: "tech" },
  { class: "la la-mobile", label: "Mobile App", category: "tech" },
  { class: "la la-wifi", label: "Wifi", category: "tech" },
  { class: "la la-cogs", label: "Cogs / Settings", category: "tech" },
  { class: "la la-key", label: "Key / API", category: "tech" },
  { class: "la la-lock", label: "Security Lock", category: "tech" },
  { class: "la la-cubes", label: "Modules", category: "tech" },

  // Ecommerce & Commerce
  { class: "la la-shopping-bag", label: "Shopping Bag", category: "commerce" },
  { class: "la la-shopping-cart", label: "Shopping Cart", category: "commerce" },
  { class: "la la-store", label: "Store", category: "commerce" },
  { class: "la la-box", label: "Box / Package", category: "commerce" },
  { class: "la la-wallet", label: "Wallet", category: "commerce" },
  { class: "la la-credit-card", label: "Credit Card", category: "commerce" },
  { class: "la la-dollar-sign", label: "Dollar", category: "commerce" },
  { class: "la la-ticket-alt", label: "Coupon Ticket", category: "commerce" },
  { class: "la la-receipt", label: "Receipt", category: "commerce" },
  { class: "la la-coins", label: "Coins / Tokens", category: "commerce" },

  // Media & Content
  { class: "la la-newspaper-o", label: "Newspaper", category: "media" },
  { class: "la la-file-alt", label: "Document", category: "media" },
  { class: "la la-image", label: "Image", category: "media" },
  { class: "la la-video", label: "Video", category: "media" },
  { class: "la la-film", label: "Film / Movie", category: "media" },
  { class: "la la-podcast", label: "Podcast", category: "media" },
  { class: "la la-camera", label: "Camera", category: "media" },
  { class: "la la-rss", label: "Blog RSS", category: "media" },
  { class: "la la-headphones", label: "Audio", category: "media" },

  // Business & Office
  { class: "la la-globe", label: "Global", category: "business" },
  { class: "la la-briefcase", label: "Briefcase", category: "business" },
  { class: "la la-building", label: "Company", category: "business" },
  { class: "la la-users", label: "Users / Team", category: "business" },
  { class: "la la-calendar", label: "Calendar", category: "business" },
  { class: "la la-bell", label: "Notification", category: "business" },
  { class: "la la-envelope", label: "Email", category: "business" },
  { class: "la la-phone", label: "Phone", category: "business" },
  { class: "la la-chart-bar", label: "Analytics", category: "business" },
  { class: "la la-map-marker", label: "Location", category: "business" },
];

export function TagIconPreview({ icon, badgeColor = "#0d6efd", color, name = "Tag Preview" }) {
  const finalColor = color || badgeColor || "#0d6efd";
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "4px 12px",
        borderRadius: "16px",
        backgroundColor: `${finalColor}15`,
        border: `1px solid ${finalColor}40`,
        color: finalColor,
        fontWeight: "600",
        fontSize: "13px",
      }}
    >
      <i className={icon || "la la-tag"} style={{ fontSize: "16px" }} />
      <span>{name}</span>
    </div>
  );
}

export function IconPickerModal({ value, onChange, visible, onCancel }) {
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("education");
  const [customIcon, setCustomIcon] = useState(value || "la la-graduation-cap");

  const filteredIcons = PRESET_ICONS.filter((item) => {
    const matchesCategory = category === "all" || item.category === category;
    const matchesSearch =
      !search ||
      item.label.toLowerCase().includes(search.toLowerCase()) ||
      item.class.toLowerCase().includes(search.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const handleSelect = (iconClass) => {
    setCustomIcon(iconClass);
    onChange(iconClass);
    if (onCancel) onCancel();
  };

  return (
    <Modal
      title={
        <div className="d-flex align-items-center gap-2">
          <i className="la la-graduation-cap text-primary" style={{ fontSize: "20px" }} />
          <span>Select Tag Icon (50+ Education & Learning Icons)</span>
        </div>
      }
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="close" type="primary" onClick={onCancel}>
          Done
        </Button>,
      ]}
      width={680}
    >
      <div className="mb-3">
        <Input
          placeholder="Search education & learning icons (e.g. cap, book, math, lab, degree, exam)..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          prefix={<i className="la la-search text-muted me-1" />}
          allowClear
        />
      </div>

      {/* Category Tabs Filter */}
      <div className="d-flex align-items-center gap-1 overflow-auto pb-2 mb-3" style={{ scrollbarWidth: "thin" }}>
        {ICON_CATEGORIES.map((cat) => {
          const active = category === cat.key;
          return (
            <button
              key={cat.key}
              type="button"
              onClick={() => setCategory(cat.key)}
              className={`btn btn-sm text-nowrap rounded-pill ${
                active ? "btn-primary shadow-sm fw-bold" : "btn-light text-secondary border"
              }`}
              style={{ fontSize: "12px", padding: "4px 12px" }}
            >
              <i className={cat.icon} /> {cat.label}
            </button>
          );
        })}
      </div>

      {/* Custom Icon Input Bar */}
      <div className="mb-3 p-2 border rounded bg-light d-flex align-items-center justify-content-between gap-2">
        <small className="text-muted fw-bold text-nowrap">Custom Icon Class:</small>
        <div style={{ flex: 1 }}>
          <Input
            size="small"
            value={customIcon}
            onChange={(e) => {
              setCustomIcon(e.target.value);
              onChange(e.target.value);
            }}
            placeholder="e.g. la la-graduation-cap or la la-microscope"
          />
        </div>
      </div>

      {/* Grid Catalogue */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)",
          gap: "8px",
          maxHeight: "340px",
          overflowY: "auto",
          padding: "4px",
        }}
      >
        {filteredIcons.length === 0 ? (
          <div className="col-12 text-center py-4 text-muted grid-span-6">
            <i className="la la-info-circle fs-3 d-block mb-1" />
            <span>No icons match "{search}". Try custom class input above.</span>
          </div>
        ) : (
          filteredIcons.map((item) => {
            const isSelected = value === item.class || customIcon === item.class;
            return (
              <Tooltip key={item.class} title={item.label}>
                <div
                  onClick={() => handleSelect(item.class)}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "8px 4px",
                    borderRadius: "8px",
                    border: isSelected ? "2px solid #0d6efd" : "1px solid #e9ecef",
                    backgroundColor: isSelected ? "#e7f1ff" : "#fff",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                >
                  <i className={item.class} style={{ fontSize: "22px", color: isSelected ? "#0d6efd" : "#495057" }} />
                  <span
                    style={{
                      fontSize: "10px",
                      marginTop: "4px",
                      color: "#6c757d",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                    }}
                  >
                    {item.label}
                  </span>
                </div>
              </Tooltip>
            );
          })
        )}
      </div>
    </Modal>
  );
}
